import React from 'react';

export const ErrorMessage = ({ message }) => (
  <div className="flex flex-col gap-4 w-full p-16 justify-center items-center text-2xl text-red-500">
    <span className="material-symbols-outlined text-9xl">warning</span>
    {message}
  </div>
);

export default ErrorMessage;